var map = {
	"./img-19-01-01.png": 9746,
	"./img-19-01-02.png": 5228,
	"./img-19-01-03.png": 3956,
	"./img-19-01-04.png": 5237,
	"./img-19-01-05.png": 3966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8206;